import React, { FC } from 'react';
import { Sticker } from '../../components/sticker/Sticker';
import { PageContainer } from '../../components/page-container/PageContainer';
import { Page, PageLeft, PageCenter } from '../../components/page/Page';
import { PageNav } from '../../components/page-nav/PageNav';
import { LawFirmMobileBar } from './sub-header/LawFirmMobileBar';
import { EntityPage } from '../../entity/components/EntityPage';

export const LawFirmLayout: FC = ({ children }) => (
  <>
    <EntityPage>
      <PageContainer>
        <Page>
          <PageLeft>
            <PageNav />
          </PageLeft>
          <PageCenter>{children}</PageCenter>
        </Page>
        <Sticker anchor="add-watcher-law-firm">
          {({ isVisible }) => <LawFirmMobileBar isVisible={isVisible} />}
        </Sticker>
      </PageContainer>
    </EntityPage>
  </>
);
